import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import RecruitmentOverview from "./index";
import { FaMagnifyingGlass } from "react-icons/fa6";

const recruitmentRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Talent Acquisition",
        basePath: "talent-acquisition",
        mainComponent: <RecruitmentOverview />,
        layout: "/console",
        icon: <FaMagnifyingGlass className="icon-item" />,
        subTitle:"Overviews",
        level:4,
        moduleId: 0,
    })
]

export default recruitmentRoutes;